import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { PortInfo } from '@libs/trip-planner-interfaces';

import type {
  AddFlightsModalInitialRoute,
  AddFligthsModalRoute,
} from '../addFlightsModal.model';

const { t } = i18n.global;

export const yourPositionLabel = t('modals.addFlights.yourPostion');

export function mapToAddFlightsModalRoute(
  initialRoute: AddFlightsModalInitialRoute
): AddFligthsModalRoute {
  return {
    from: initialRoute.from?.displayText || yourPositionLabel,
    fromAirport: getEmptyAirport(),
    to: initialRoute.to?.displayText || yourPositionLabel,
    toAirport: getEmptyAirport(),
    isEnabled: true,
    ingredientId: initialRoute.ingredientId,
    isLast: initialRoute.isLast,
  };
}

function getEmptyAirport(): PortInfo {
  return {
    code: undefined,
    name: undefined,
    label: undefined,
  };
}
